import React from "react";
import { motion } from "framer-motion";

/**
 * PageTransition — TASK-014
 * Wrapper de transição de página usando framer-motion.
 * Aplica fade + leve deslocamento vertical para dar fluidez app-like.
 *
 * Uso: Envolver o conteúdo dentro de AnimatePresence no router.
 *
 * Props:
 *   - children: conteúdo da página
 *   - variant: "fade" (padrão) | "slide" — tipo de transição
 */

const variants = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  },
  slide: {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -12 },
  },
};

const transition = {
  duration: 0.2,
  ease: "easeInOut",
};

export default function PageTransition({ children, variant = "slide" }) {
  const v = variants[variant] || variants.slide;

  return (
    <motion.div
      initial={v.initial}
      animate={v.animate}
      exit={v.exit}
      transition={transition}
      style={{ minHeight: "100vh" }}
    >
      {children}
    </motion.div>
  );
}